import { gql, TypedDocumentNode } from '@apollo/client';
import type { Batch } from '../models/Batch';

export const ADD_BATCH_MUTATION: TypedDocumentNode<{ added: boolean }, { productId: number; amount: number }> = gql`
  mutation AddBatch($productId: Int!, $amount: Float!) {
    added: addBatch(productId: $productId, amount: $amount)
  }
`;

export const CALCULATE_BATCH_MUTATION: TypedDocumentNode<{ batch: Batch }, { productId: number; amount: number }> = gql`
  mutation CalculateBatchForProduct($productId: Int!, $amount: Float!) {
    batch: calculateBatchForProduct(productId: $productId, amount: $amount) {
      product {
        id,
        name
      },
      productId,
      amount,
      calculatedProductItems {
        id,
        itemId,
        item {
          id,
          name
        },
        productId,
        quantity,
        productBatchQuantity,
        remainingProductBatchQuantity,
        productBatchQuantityMet,
        notes,
        calculatedItemCost,
        calculatedConsumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            lotNumber,
            quantityOnHand,
            vendorId,
            vendor {
              id,
              name
            },
            purchaseOrder {
              dateTimePurchased
            },
            remainingQuantityOnHand
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      lotNumber,
      notes,
      totalCost
    }
  }
`;

export const RECALCULATE_BATCH_MUTATION: TypedDocumentNode<{ batch: Batch }, { batchId: number; amount: number }> = gql`
  mutation recalculateBatchForProduct($batchId: Int!, $amount: Float!) {
    batch: recalculateBatchForProduct(batchId: $batchId, amount: $amount) {
      id,
      product {
        id,
        name
      },
      productId,
      amount,
      calculatedProductItems {
        id,
        itemId,
        item {
          id,
          name
        },
        productId,
        quantity,
        productBatchQuantity,
        remainingProductBatchQuantity,
        productBatchQuantityMet,
        notes,
        calculatedItemCost,
        calculatedConsumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            lotNumber,
            quantityOnHand,
            vendorId,
            vendor {
              id,
              name
            },
            purchaseOrder {
              dateTimePurchased
            },
            remainingQuantityOnHand
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      lotNumber,
      notes,
      totalCost
    }
  }
`;

export const COMPLETE_BATCH_MUTATION: TypedDocumentNode<{ completed: boolean }, { batchId: number; notes?: string | null }> = gql`
  mutation CompleteBatch($batchId: Int!, $notes: String) {
    completed: completeBatch(batchId: $batchId, notes: $notes)
  }
`;

export const UPDATE_BATCH_MUTATION: TypedDocumentNode<{ batch: Batch }, { id: number; updatedAmount: number }> = gql`
  mutation UpdateBatch($id: Int!, $updatedAmount: Float!) {
    batch: updateBatch(id: $id, updatedAmount: $updatedAmount) {
      product {
        id,
        name
      },
      amount,
      calculatedProductItems {
        id,
        itemId,
        item {
          id,
          name
        },
        productId,
        quantity,
        productBatchQuantity,
        remainingProductBatchQuantity,
        productBatchQuantityMet,
        notes,
        calculatedItemCost,
        calculatedConsumedInventoryItems {
          id,
          inventoryItemId,
          inventoryItem {
            id,
            lotNumber,
            quantityOnHand,
            vendorId,
            vendor {
              id,
              name
            },
            purchaseOrder {
              dateTimePurchased
            },
            remainingQuantityOnHand
          },
          quantityNeeded,
          quantityUsed,
          totalProductBatchQuantity,
          totalItemCost
        }
      },
      lotNumber
    }
  }
`;

export const DELETE_BATCH_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteBatchById($id: Int!) {
    deleted: deleteBatchById(id: $id)
  }
`;
